import styled, { css } from 'styled-components'

type IsMobile = {
  isMobile: boolean
}

export const Container = styled.div<IsMobile>`
  margin-top: 7rem;
  display: flex;
  justify-content: center;
  gap: 8rem;
  min-height: calc(100vh - 6rem);
  margin-bottom: 30rem;
  
  ${({ isMobile }) => isMobile && css`
    flex-direction: column;
    margin-top: 3rem;
    min-height: 0;
    align-items: center;
    gap: 0;
  `}
`